// @flow
/**
 * @module Reducers/Workflows
 * @desc Workflows Reducer
 */

import { handleActions } from 'redux-actions';
import { WorkflowConstants } from 'constants/workflowConstants';
import { requestPending, requestSuccess, requestFail } from 'components/Fetch';

const initialState = {
};

export default handleActions({
  [requestPending(WorkflowConstants.NEXT_ACTION)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(WorkflowConstants.NEXT_ACTION)]: (state, action) => ({
    ...action.payload,
    isLoading: false,
  }),
  [requestFail(WorkflowConstants.NEXT_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),

  [requestPending(WorkflowConstants.PREVIOUS_ACTION)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(WorkflowConstants.PREVIOUS_ACTION)]: (state, action) => ({
    ...action.payload,
    isLoading: false,
  }),
  [requestFail(WorkflowConstants.PREVIOUS_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),

  [requestPending(WorkflowConstants.CHECKIN_ACTION)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(WorkflowConstants.CHECKIN_ACTION)]: (state, action) => ({
    ...action.payload,
    isLoading: false,
  }),
  [requestFail(WorkflowConstants.CHECKIN_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
}, initialState);
